module.exports = __webpack_public_path__ + "fonts/Stelvio-Grotesk-Extra-Bold.f5fff0c.woff";